import { render, staticRenderFns } from "./clientCifInput.vue?vue&type=template&id=2382c2d8&"
import script from "./clientCifInput.vue?vue&type=script&lang=js&"
export * from "./clientCifInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports